import { formatMoney } from '@staccx/bento'
import { formatDate } from '../../../V3/helpers/formatDate'

export function workshop() {
  return [
    {
      accessorKey: 'date',
      id: 'date',
      header: () => <span>Dato</span>,
      cell: ({ row }) => {
        const date = formatDate(row.original.date)
        return date
      },
      meta: { alignmentType: 'date' },
    },
    {
      accessorKey: 'description',
      id: 'description',
      header: () => <span>Beskrivelse</span>,
      cell: ({ row }) => {
        const location = row.original.description
        return location
      },
      meta: { alignmentType: 'string' },
    },

    {
      accessorKey: 'price',
      id: 'price',
      header: () => <span>Pris</span>,
      cell: ({ row }) => {
        const amount = formatMoney(row.original.price)
        return `${amount} NOK`
      },
      meta: { alignmentType: 'string' },
    },
  ]
}
